// src/components/describeTermI18n.js
// describeTerm() from utils/subPayTerms, in the viewer's language.
// English mode returns the original describeTerm() text unchanged.
import { computeTermOwed, describeTerm } from "../utils/subPayTerms";
import { translateUi } from "../i18n";

export const describeTermFor = (lang, job, term, money) => {
  if (lang !== "es") return describeTerm(job, term, money);
  const t = (s, v) => translateUi(lang, s, v);
  const c = computeTermOwed(job, term);
  if (c.skipped === "recurring") return t("Recurring job - use Sub Pay per visit");
  if (c.mode === "project") {
    return c.own
      ? t("Project price {amount}", { amount: money(c.projectAmount) })
      : t("Project price {amount} (owed on the first job)", { amount: money(c.projectAmount) });
  }
  const base = t("{workers} worker(s) × {rate}/day × {days} day(s)", {
    workers: c.workers,
    rate: money(c.rate),
    days: c.days,
  });
  if (!c.splitDays) return base;
  const split = t("split with {others} other job(s) on {days} day(s)", { others: c.maxShared - 1, days: c.splitDays });
  return `${base} · ${split} = ${money(c.amount)}`;
};
